"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import LenisProvider from "@/components/landing/LenisProvider";
import { LeadDiagnosticModal } from "@/components/landing/LeadDiagnosticModal";
import Navbar from "@/components/landing/Navbar";
import HeroSection from "@/components/landing/HeroSection";
import SocialProofBar from "@/components/landing/SocialProofBar";
import ProblemSection from "@/components/landing/ProblemSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import ProductShowcase from "@/components/landing/ProductShowcase";
import ObjectionsSection from "@/components/landing/ObjectionsSection";
import LeadFormSection from "@/components/landing/LeadFormSection";
import Footer from "@/components/landing/Footer";

const DISABLE_LANDING = false;
const DISABLE_DIAGNOSTIC = true;

export default function LandingPage() {
  const router = useRouter();
  const [diagnosticOpen, setDiagnosticOpen] = useState(false);

  useEffect(() => {
    if (DISABLE_LANDING) {
      router.push("/dashboard");
    }
  }, [router]);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", "dark");
  }, []);

  const openDiagnostic = DISABLE_DIAGNOSTIC ? undefined : () => setDiagnosticOpen(true);

  if (DISABLE_LANDING) return null;

  return (
    <LenisProvider>
      <div className="min-h-screen text-white font-sans overflow-x-hidden selection:bg-primary/30 selection:text-white">
        <Navbar onOpenDiagnostic={openDiagnostic} />

        <main>
          <HeroSection onOpenDiagnostic={openDiagnostic} />
          <SocialProofBar />
          <ProblemSection />
          <FeaturesSection />
          <ProductShowcase />
          <ObjectionsSection />
          <LeadFormSection />
        </main>

        {!DISABLE_DIAGNOSTIC && (
          <LeadDiagnosticModal
            open={diagnosticOpen}
            onOpenChange={setDiagnosticOpen}
          />
        )}

        <Footer />
      </div>
    </LenisProvider>
  );
}
